import { createStyles, makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import { JupiterTheme } from '../../theme/types';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    root: {
      borderRadius: '2px 8px',
      display: 'block',
      lineHeight: 1.5,
      height: 22,
      transformOrigin: 'center',
      letterSpacing: 1.6,
      padding: theme.spacing(0.25, 1),
      fontSize: 11,
      fontWeight: 700,
      fontFamily: `'Ubuntu', sans-serif`,
      textTransform: 'uppercase',
      background: theme.palette.gradient.j1,
      boxShadow: '2px 3px 5px -2px rgba(0, 6, 42, 0.4)',
      borderBottom: 'solid 1px ' + theme.palette.coolGrey[400],
      borderRight: 'solid 1px ' + theme.palette.coolGrey[400],
      color: theme.palette.common.white,
      pointerEvents: 'none',
    },
  })
);

export interface Props {
  classes?: any;
}

const BetaRibbon = ({ classes: customClasses }: Props) => {
  const classes = useStyles();

  return <span className={clsx(classes.root, customClasses)}>BETA</span>;
};

export default BetaRibbon;
